import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { EntityReferenceBasic } from '@/shared/types';

import type { TagCategoryItem } from '@/entities/tags/domain';

type UpdateClassificationRequest = {
  name: string;
  displayName?: string;
  description?: string;
  provider?: 'system' | 'user';
  mutuallyExclusive?: boolean;
  domains?: string[];
  owners?: EntityReferenceBasic[];
};

export const updateClassificationApi = async (request: UpdateClassificationRequest): Promise<TagCategoryItem> => {
  const { data } = await openMetadataApiClient.put<TagCategoryItem>('/classifications', request);
  return data;
};

export type { UpdateClassificationRequest };
